// DevTools deterrent — client-side only. NON è vera sicurezza, solo un deterrente.
// I dati veri sono sempre protetti server-side (auth JWT + brute-force protection).

export function installDevToolsDeterrent() {
  if (typeof window === 'undefined') return;
  if (window.__csDeterrentInstalled) return;
  window.__csDeterrentInstalled = true;

  // Blocca menu contestuale
  document.addEventListener('contextmenu', (e) => {
    e.preventDefault();
  });

  // Blocca F12, Ctrl+Shift+I/J/C, Ctrl+U
  document.addEventListener('keydown', (e) => {
    const k = e.key;
    // F12
    if (k === 'F12') { e.preventDefault(); return false; }
    // Ctrl+Shift+I / J / C (developer tools)
    if ((e.ctrlKey || e.metaKey) && e.shiftKey && ['I', 'J', 'C'].includes((k || '').toUpperCase())) {
      e.preventDefault();
      return false;
    }
    // Ctrl+U (view source)
    if ((e.ctrlKey || e.metaKey) && (k || '').toUpperCase() === 'U') {
      e.preventDefault();
      return false;
    }
    // Ctrl+S (save page)
    if ((e.ctrlKey || e.metaKey) && (k || '').toUpperCase() === 'S') {
      e.preventDefault();
      return false;
    }
  });
}
